import DataForm from "../Editor/DataForm";
import { EditCtrl } from "../Editor/index"

export default class OdberneMiestoEditCtrl extends EditCtrl {

  static $inject = ["item", "saveHandler",  "opmStatuses"];

  constructor(item, saveHandler, opmStatuses,){
    super(item, saveHandler, opmStatuses);
    this.loadOpmStatuses(opmStatuses);
    this.load(item);
    this.resetValue = JSON.parse(JSON.stringify(item));
  }

  save(){
    this.saveHandler(this.item.id, this.item).then(item => this.load(this.item));
  }

  loadOpmStatuses(opmStatuses){
    this.opmStatuses = opmStatuses;
  }  

  reset() {
  	this.item = JSON.parse(JSON.stringify(this.resetValue));
  }


}



// WEBPACK FOOTER //
// ./src/OdberneMiesto/OdberneMiestoEditCtrl.js